import script from "./LucePropositionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./LucePropositionPanel.vue?vue&type=script&setup=true&lang=js"

import "./LucePropositionPanel.vue?vue&type=style&index=0&id=f5eab19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5eab19c"]])

export default __exports__